import { __decorate } from "tslib";
import { LitElement, html, css } from "lit";
import { customElement } from "lit/decorators.js";
import { when } from "lit/directives/when.js";
import { repeat } from "lit/directives/repeat.js";
let SeToasterElement = class SeToasterElement extends LitElement {
    constructor() {
        super(...arguments);
        this._toasts = [];
    }
    firstUpdated() { }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener("resize", () => this.resize());
    }
    disconnectedCallback() {
        window.removeEventListener("resize", () => this.resize());
        super.disconnectedCallback();
    }
    resize() {
        this.updateAsync();
    }
    removeFirstToast() {
        if (this._toasts.length > 0) {
            this._toasts.splice(0, 1);
        }
        this.updateAsync();
    }
    clear() {
        this._toasts = [];
        this.updateAsync();
    }
    hideToast(toast) {
        const index = this._toasts.indexOf(toast);
        const el = this.shadowRoot.children[index];
        if (el)
            el.style.opacity = "0.1";
        setTimeout(() => {
            this._toasts = this._toasts.filter((p) => p !== toast);
            this.updateAsync();
        }, 1000);
    }
    addToast(toast) {
        var _a;
        toast.opacity = (_a = toast.opacity) !== null && _a !== void 0 ? _a : 1;
        this._toasts.push(toast);
        if (toast.timeout) {
            toast.timeoutHandle = setTimeout(() => this.hideToast(toast), toast.timeout);
        }
        this.updateAsync();
    }
    async updateAsync() {
        this.requestUpdate();
        await this.updateComplete;
        const rect = this.getBoundingClientRect();
        if (rect.height > window.innerHeight - 10) {
            if (this._toasts.length > 1)
                this.removeFirstToast();
            else {
                this.style.height = window.innerHeight - 20 + "px";
                this.style.overflow = "hidden";
            }
        }
        this.style.left = window.innerWidth - 10 - rect.width + "px";
        this.style.top = "10px";
    }
    render() {
        return html `
            ${repeat(this._toasts, (toast) => toast.id, (toast) => html `
                    <div class="toast" @click=${() => this.hideToast(toast)} style="display:flex;gap:10px">
                        <div><fa-icon single-color=${toast.iconColor} fa-class="${toast.icon}"></fa-icon></div>
                        <div style="width:100%">
                            <div class="header">
                                <div>${toast.title}</div>
                                <div class="icon"><fa-icon scale="0.9" fa-class="far fa-xmark"></fa-icon></div>
                            </div>
                            <div class="body">
                                ${when(toast.description, () => html `<div style="overflow-wrap: break-word;">${toast.description}</div>`)}
                                ${toast.descriptions
            ? html `<ul style="padding-left:10px">
                                          ${toast.descriptions.map((description) => html `<li style="margin-top:10px;overflow-wrap: break-word;">${description}</li>`)}
                                      </ul>`
            : html ``}
                            </div>
                        </div>
                    </div>
                `)}
        `;
    }
};
SeToasterElement.styles = css `
        :host[hidden] {
            display: hidden;
        }
        :host {
            display: block;
            font: var(--font-small);
            position: absolute;
            z-index: 3000;
            left: -1000px;
            top: -1000px;
            width: 320px;
        }
        .toast {
            box-shadow: 1px 1px 5px dimgray;
            margin-bottom: 2px;
            padding: 5px 10px 5px 10px;
            border-radius: 3px 3px;
            transition: all 1s;
            overflow: hidden;
            background-color: white;
            color: black;
            border: 1px solid gainsboro;
        }
        .header {
            width: 100%;
            margin-bottom: 6px;
            display: flex;
            justify-content: space-between;
            font-weight: bold;
        }
        .icon {
            width: 20px;
            height: 20px;
            text-align: center;
            vertical-align: middle;
            border-radius: 2px;
        }
        .icon:hover {
            color: white;
            background-color: crimson;
        }
    `;
SeToasterElement = __decorate([
    customElement("se-toaster")
], SeToasterElement);
export { SeToasterElement };
//# sourceMappingURL=toaster.element.js.map